export const IS_SENTRY_ENABLED = ['preview', 'development', 'production'].includes(
  process.env.VERCEL_ENV as string
);
